// extracted by mini-css-extract-plugin
export default {"infoMessage":"InfoMessage_infoMessage__C32HA","ml10":"InfoMessage_ml10__kSisB"};